<template>
  <div>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="profilesList"
      :items="profilesList"
      :fields="profilesFields"
      :filter="filter"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="currentRowProfile"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      currentRowProfile: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      profilesFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Profile name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    showAdd () {
      this.currentRowProfile = {
        id: 0,
        name: '',
        supp_volumes: '',
        isPortStartOffset: false,
        port_start_offset: 1,
        isEnableTabRemoteID: false,
        isEnableTabPortID: false,
        isEnableTabVlanID: false,
        tec_id_meta: {
          len: 0,
          offset: 0,
          disposition: 0,
          type: 0
        },
        vlan_id_meta: {
          len: 0,
          offset: 0,
          disposition: 0,
          type: 0
        },
        port_id_meta: {
          len: 0,
          offset: 0,
          disposition: 0,
          type: 0
        }
      }
      this.$root.$emit('bv::show::modal', 'modalEditInventoryProfiles', '#btnShow')
    },
    editItem (item) {
      this.currentRowProfile = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditInventoryProfiles', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Switch profiles"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Inventory/DELETE_SWITCH_TYPES', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Inventory/GET_SWITCH_TYPES')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    profilesList () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Inventory/SWITCH_TYPES']))
      for (let el of copy) {
        el.isEnableTabRemoteID = false
        el.isEnableTabPortID = false
        el.isEnableTabVlanID = false
        if (el.tec_id_meta.len !== 0 || el.tec_id_meta.offset !== 0 || el.tec_id_meta.disposition !== 0 || el.tec_id_meta.type !== 0) {
          el.isEnableTabRemoteID = true
        }
        if (el.vlan_id_meta.len !== 0 || el.vlan_id_meta.offset !== 0 || el.vlan_id_meta.disposition !== 0 || el.vlan_id_meta.type !== 0) {
          el.isEnableTabVlanID = true
        }
        if (el.port_id_meta.len !== 0 || el.port_id_meta.offset !== 0 || el.port_id_meta.disposition !== 0 || el.port_id_meta.type !== 0) {
          el.isEnableTabPortID = true
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Inventory/GET_SWITCH_TYPES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/inventory/inventoryProfiles/main.vue